import type { JSX, ReactNode } from 'react';
import styles from './FeuillePiece.module.css';

export interface FeuillePieceProps {
  emetteur: string; // nom de la galerie de session
  nature: ReactNode; // « Facture », pastille « Avoir », « Bon de dépôt »…
  destinataire: { legende: string; nom: string; complement?: ReactNode };
  numero: ReactNode; // titre de page (h1)
  brouillon?: boolean;
  tampon?: ReactNode; // pastille d'état
  meta?: ReactNode; // « Émise le … »
  etat?: string; // data-etat
  pied?: ReactNode; // mentions
  children: ReactNode; // sections (lignes, totaux)
  className?: string;
}

/** Feuille papier d'une pièce (facture, avoir, offre, bon, contrat) : l'objet qu'on imprime. */
export function FeuillePiece({
  emetteur,
  nature,
  destinataire,
  numero,
  brouillon = false,
  tampon,
  meta,
  etat,
  pied,
  children,
  className,
}: FeuillePieceProps): JSX.Element {
  return (
    <article className={[styles.feuille, className].filter(Boolean).join(' ')} data-etat={etat}>
      <header className={styles.entete}>
        <span className={styles.emetteur}>{emetteur}</span>
        <span className={styles.nature}>{nature}</span>
      </header>
      <div className={styles.piece}>
        <div className={styles.destinataire}>
          <span className={styles.legende}>{destinataire.legende}</span>
          <span className={styles.destinataireNom}>{destinataire.nom}</span>
          {destinataire.complement}
        </div>
        <div className={styles.reference}>
          <div className={styles.numeroLigne}>
            <h1 className={styles.numero} data-brouillon={brouillon ? 'oui' : undefined}>
              {numero}
            </h1>
            {tampon ? <span className={styles.tampon}>{tampon}</span> : null}
          </div>
          {meta ? <p className={styles.meta}>{meta}</p> : null}
        </div>
      </div>
      {children}
      {pied ? <footer className={styles.pied}>{pied}</footer> : null}
    </article>
  );
}
